import _ from 'lodash';
import React, { useMemo } from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { createPortfolioCovenantsChartConfig } from 'packages/portfolio/ui/covenants/CovenantsContainer';
import { PortfolioCovenantChartTemplate } from 'packages/portfolio/ui/covenants/PortfolioCovenantChartTemplate';

type DigitalMonthlyReportSinglePortfolioCovenantDetailProps = {
  creditFacilityId: string;
  creditAgreementPortfolioCovenants: CreditAgreement.DomainEntity.PortfolioCovenantProperty[];
  covenantKey: string;
};
export const DigitalMonthlyReportSinglePortfolioCovenantDetail = ({
  creditFacilityId,
  creditAgreementPortfolioCovenants,
  covenantKey,
}: DigitalMonthlyReportSinglePortfolioCovenantDetailProps) => {
  // it's possible for the covenantKey of a portfolio covenant calculation to no longer exist in the current CA, if it's been deleted
  // we will still show the calculations and graphs as historical data, but will not be able to parse out the thresholdType (min vs max) later downstream, which is fine
  const creditAgreementPortfolioCovenant:
    | CreditAgreement.DomainEntity.PortfolioCovenantProperty
    | undefined = useMemo(() => {
    return _.find(
      creditAgreementPortfolioCovenants,
      (portfolioCovenant) => portfolioCovenant.covenantKey === covenantKey,
    );
  }, [covenantKey, creditAgreementPortfolioCovenants]);

  return (
    <PortfolioCovenantChartTemplate
      creditFacilityId={creditFacilityId}
      chartTitle={commonUtils.toTitleCase(covenantKey)}
      covenantKey={covenantKey}
      chartConfig={createPortfolioCovenantsChartConfig('percentage')}
      key={`portfolio-covenant-chart-${covenantKey}`}
      creditAgreementPortfolioCovenant={creditAgreementPortfolioCovenant}
    />
  );
};
